import React, { useState } from 'react';
import PropTypes from 'prop-types';
import css from './ServicesBlock.css';
import Icon from "SF/MaterialIcon";
import { getServiceProfileUrl, getServiceSchedulingUrl } from '../utils/successNetworkURL';

const ServicesBlock = ({services, sectionId}) => {
  const [isExpanded, setExpanded] = useState(true);
  return (
    <div className={css['container']} data-role="servicesContainer">
      <button onClick={() => setExpanded(!isExpanded)} aria-label={`Services" ${isExpanded ? "Expanded" : "Collapsed"}`}>
        <Icon icon={isExpanded ? "keyboard_arrow_down" : "keyboard_arrow_right"} />
        Services
      </button>
      {isExpanded && (
        <div className={css['servicesContainer']}>
          {services.map(service => (
            <div key={service.id} className={css['service']}>
              <div className={css['body']}>
                <a href={getServiceProfileUrl(service.id)} data-role="serviceProfileLink">{service.serviceDisplayName || service.name}</a>
                {service.hoursOperation && <div>
                  <Icon icon="schedule" /> <span>{service.hoursOperation}</span>
                </div>}
                {service.location && <div>
                  <Icon icon="place" /> <span>{service.location}</span>
                </div>}
                {service.phone && <div>
                  <Icon icon="phone" /> <span>{service.phone}</span>
                </div>}
              </div>
              <hr />
              <div className={css['footer']}>
                {service.onlineSchedulingEnabled && <a href={getServiceSchedulingUrl(service.id, sectionId)}>Schedule</a>}
                {service.phone && <a href={`tel:${service.phone}`} aria-label={`Call ${service.name}`}>Call</a>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

ServicesBlock.propTypes = {
  services: PropTypes.array.isRequired,
  sectionId: PropTypes.number.isRequired
}

export default ServicesBlock;
